import React, { useState, useContext } from 'react';
import './Shop.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import { ValuationContext } from '../../context/ValuationContext';
import axios from 'axios';
import { set } from 'mongoose';
import { useTranslation } from 'react-i18next';

const Shop = () => {
  const { t, i18n } = useTranslation();
  const [tokenCount, setTokenCount] = useState(null);
  const [user, setUser] = useState(null);
  const [location, setLocation] = useState('TR'); // Default olarak TR
  const [loadingPackage, setLoadingPackage] = useState(null);
  const [iframeToken, setIframeToken] = useState(null);
  const [iframeOrderId, setIframeOrderId] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [usdToTryRate, setUsdToTryRate] = useState(40); // USD to TRY kuru (varsayılan: 40)



  React.useEffect(() => {
    // Sayfa yüklendiğinde en üste scroll
    window.scrollTo(0, 0);

    const fetchUserData = async () => {
      try {
        const response = await axios.get(`/api/user/me`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('userToken')}`,
            'Content-Type': 'application/json'
          }
        });

        setTokenCount(response.data.token || 0);
        setUser(response.data);
        // Sadece TR dışında bir lokasyon gelirse güncelle, yoksa TR default kalır
        if (response.data.location && response.data.location !== 'TR' && response.data.location !== 'Türkiye') {
          setLocation(response.data.location);
        }


      } catch (err) {
        console.error('❌ API Error:', err.response?.data || err.message);
      }
    };

    fetchUserData();
  }, []);

  React.useEffect(() => {
    console.log('Location value:', location, typeof location);
  }, [location]);

  // USD to TRY kuru çek
  React.useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
        const data = await response.json();
        const rate = data.rates.TRY;
        if (rate && rate > 0) {
          setUsdToTryRate(rate);
          console.log('USD to TRY rate fetched:', rate);
        }
      } catch (error) {
        console.error('Kur bilgisi alınamadı, varsayılan 40 TL kullanılıyor:', error);
      }
    };

    fetchExchangeRate();
  }, []);

  // Para birimi belirleme - Dil tercihine göre (TR dili = TL, diğerleri = USD)
  const currentLanguage = i18n.language || 'tr';
  const isTurkishCurrency = currentLanguage.startsWith('tr');

  const isTurkishUser = () => {
    return isTurkishCurrency;
  };

  // Fiyat formatlama helper function
  const formatPrice = (pkg) => {
    const isTurkish = isTurkishUser();
    console.log('formatPrice called:', { isTurkish, pkg: pkg.name });

    if (isTurkish) {
      return {
        price: `₺${pkg.price.toLocaleString('tr-TR')}`,
        originalPrice: pkg.originalPrice ? `₺${pkg.originalPrice.toLocaleString('tr-TR')}` : null
      };
    } else {
      return {
        price: `$${pkg.usdPrice.toLocaleString('en-US', {
          minimumFractionDigits: Number.isInteger(pkg.usdPrice) ? 0 : 2,
          maximumFractionDigits: 2
        })}`,
        originalPrice: pkg.usdOriginalPrice ? `$${pkg.usdOriginalPrice.toLocaleString('en-US')}` : null
      };
    }
  };

  const packageContent = isTurkishCurrency ? {
    basic: {
      name: '1 Rapor',
      description: '1 Girişim Analizi ve Değerleme Raporu',
      features: [
        '1 girişim analizi ve değerleme raporu',
        'DCF + Berkus değerleme yöntemleri',
        'Risk analizi',
        'Çoklu para biriminde değerleme',
        'Yatırımcı raporu oluşturma ve paylaşma',
        'Finansal/veri çıktılarının indirilmesi',
        '1 yıl platform erişimi',
        '15 dk platform kullanım eğitimi'
      ]
    },
    standard: {
      name: '25 Rapor',
      description: '25 Girişim Analizi ve Değerleme Raporu',
      features: [
        '25 girişim analizi ve değerleme raporu',
        'DCF + Berkus değerleme yöntemleri',
        'Risk analizi',
        'Çoklu para biriminde değerleme',
        'Finansal/veri çıktılarının indirilmesi',
        '1 yıl platform erişimi',
        '1 saatlik online platform kullanım eğitimi',
        'Tüm girişim raporlarını tek ekrandan yönetme'
      ]
    },
    premium: {
      name: '50 Rapor',
      description: '50 Girişim Analizi ve Değerleme Raporu',
      features: [
        '50 girişim analizi ve değerleme raporu',
        'DCF + Berkus değerleme yöntemleri',
        'Risk analizi',
        'Çoklu para biriminde değerleme',
        'Finansal/veri çıktılarının indirilmesi',
        '1 yıl platform erişimi',
        '1 saatlik online platform kullanım eğitimi',
        '2 saat soru-cevap mentorluk',
        'Tüm girişim raporlarını tek ekrandan yönetme'
      ]
    },
    enterprise100: {
      name: '100 Rapor',
      description: '100 Girişim Analizi ve Değerleme Raporu',
      features: [
        '100 girişim analizi ve değerleme raporu', 'DCF + Berkus değerleme yöntemleri', 'Risk analizi',
        'Çoklu para biriminde değerleme', 'Finansal/veri çıktılarının indirilmesi', '2 yıl platform erişimi',
        '2 saatlik online platform kullanım eğitimi', '1 saat soru-cevap mentorluk',
        'Tüm girişim raporlarını tek ekrandan yönetme'
      ]
    },
    enterprise250: {
      name: '250 Rapor',
      description: '250 Girişim Analizi ve Değerleme Raporu',
      features: [
        '250 girişim analizi ve değerleme raporu', 'DCF + Berkus değerleme yöntemleri', 'Risk analizi',
        'Çoklu para biriminde değerleme', 'Finansal/veri çıktılarının indirilmesi', '2 yıl platform erişimi',
        '2 saatlik online platform kullanım eğitimi', '2 saat soru-cevap mentorluk',
        'Tüm girişim raporlarını tek ekrandan yönetme'
      ]
    },
    enterprise400: {
      name: '400 Rapor',
      description: '400 Girişim Analizi ve Değerleme Raporu',
      features: [
        '400 girişim analizi ve değerleme raporu', 'DCF + Berkus değerleme yöntemleri', 'Risk analizi',
        'Çoklu para biriminde değerleme', 'Finansal/veri çıktılarının indirilmesi', '2 yıl platform erişimi',
        '2 saatlik online platform kullanım eğitimi', '3 saat soru-cevap mentorluk',
        'Tüm girişim raporlarını tek ekrandan yönetme'
      ]
    }
  } : {
    basic: {
      name: '1 Report',
      description: '1 Startup Analysis and Valuation Report',
      features: [
        '1 startup analysis and valuation report',
        'DCF + Berkus valuation methods',
        'Risk analysis',
        'Valuation in multiple currencies',
        'Create and share investor reports',
        'Download financial/data outputs',
        '1-year platform access',
        '15-minute platform usage training'
      ]
    },
    standard: {
      name: '25 Reports',
      description: '25 Startup Analysis and Valuation Reports',
      features: [
        '25 startup analysis and valuation reports',
        'DCF + Berkus valuation methods',
        'Risk analysis',
        'Valuation in multiple currencies',
        'Download financial/data outputs',
        '1-year platform access',
        '1-hour online platform usage training',
        'Manage all startup reports from one screen'
      ]
    },
    premium: {
      name: '50 Reports',
      description: '50 Startup Analysis and Valuation Reports',
      features: [
        '50 startup analysis and valuation reports',
        'DCF + Berkus valuation methods',
        'Risk analysis',
        'Valuation in multiple currencies',
        'Download financial/data outputs',
        '1-year platform access',
        '1-hour online platform usage training',
        '2-hour Q&A mentoring',
        'Manage all startup reports from one screen'
      ]
    },
    enterprise100: {
      name: '100 Reports',
      description: '100 Startup Analysis and Valuation Reports',
      features: [
        '100 startup analysis and valuation reports', 'DCF + Berkus valuation methods', 'Risk analysis',
        'Valuation in multiple currencies', 'Download financial/data outputs', '2-year platform access',
        '2-hour online platform usage training', '1-hour Q&A mentoring',
        'Manage all startup reports from one screen'
      ]
    },
    enterprise250: {
      name: '250 Reports',
      description: '250 Startup Analysis and Valuation Reports',
      features: [
        '250 startup analysis and valuation reports', 'DCF + Berkus valuation methods', 'Risk analysis',
        'Valuation in multiple currencies', 'Download financial/data outputs', '2-year platform access',
        '2-hour online platform usage training', '2-hour Q&A mentoring',
        'Manage all startup reports from one screen'
      ]
    },
    enterprise400: {
      name: '400 Reports',
      description: '400 Startup Analysis and Valuation Reports',
      features: [
        '400 startup analysis and valuation reports', 'DCF + Berkus valuation methods', 'Risk analysis',
        'Valuation in multiple currencies', 'Download financial/data outputs', '2-year platform access',
        '2-hour online platform usage training', '3-hour Q&A mentoring',
        'Manage all startup reports from one screen'
      ]
    }
  };

  const packages = [
    {
      id: 'basic',
      name: packageContent.basic.name,
      description: packageContent.basic.description,

      //TL
      price: 2500,
      usdPrice: 62.5,

      reports: 1,
      features: packageContent.basic.features,
      popular: false
    },
    {
      id: 'standard',
      name: packageContent.standard.name,
      description: packageContent.standard.description,

      //TL
      price: 50000,
      //USD
      usdPrice: 1250,

      reports: 25,
      unitPrice: isTurkishCurrency ? 'Birim fiyat: ₺2.000' : 'Unit price: $50',
      features: packageContent.standard.features,
      popular: false
    },
    {
      id: 'premium',
      name: packageContent.premium.name,
      description: packageContent.premium.description,

      //TL
      price: 87500,
      //USD
      usdPrice: 2187.5,

      reports: 50,
      unitPrice: isTurkishCurrency ? 'Birim fiyat: ₺1.750' : 'Unit price: $43.75',
      features: packageContent.premium.features,
      popular: false
    },
    {
      id: 'enterprise100',
      name: packageContent.enterprise100.name,
      description: packageContent.enterprise100.description,
      price: 150000,
      usdPrice: 3750,
      reports: 100,
      unitPrice: isTurkishCurrency ? 'Birim fiyat: ₺1.500' : 'Unit price: $37.50',
      features: packageContent.enterprise100.features,
      popular: false
    },
    {
      id: 'enterprise250',
      name: packageContent.enterprise250.name,
      description: packageContent.enterprise250.description,
      price: 300000,
      usdPrice: 7500,
      reports: 250,
      unitPrice: isTurkishCurrency ? 'Birim fiyat: ₺1.200' : 'Unit price: $30',
      features: packageContent.enterprise250.features,
      popular: false
    },
    {
      id: 'enterprise400',
      name: packageContent.enterprise400.name,
      description: packageContent.enterprise400.description,
      price: 400000,
      usdPrice: 10000,
      reports: 400,
      unitPrice: isTurkishCurrency ? 'Birim fiyat: ₺1.000' : 'Unit price: $25',
      features: packageContent.enterprise400.features,
      popular: false
    }
  ];

  const handlePurchase = async (packageData) => {
    setLoadingPackage(packageData.id);
    try {
      const userRes = await axios.get(`api/user/me`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('userToken')}`,
          'Content-Type': 'application/json'
        }
      });
      console.log('Kullanıcı verisi:', userRes.data);
      let userData = userRes?.data?.user;
      if (!userData || !userData._id) throw new Error('Kullanıcı bilgisi alınamadı');

      // Fiyatı TL cinsinden hesapla (PayTR sadece TL kabul eder)
      let priceInTL;
      let originalCurrency;
      let finalPrice;

      if (isTurkishCurrency) {
        // Türkçe: Direkt TL fiyatı + KDV
        priceInTL = packageData.price;
        originalCurrency = 'TL';
        finalPrice = priceInTL * 1.2; // KDV dahil
      } else {
        // İngilizce: USD'yi TL'ye çevir (KDV yok)
        priceInTL = packageData.usdPrice;
        originalCurrency = 'USD';
        finalPrice = priceInTL; // KDV dahil değil
      }

      console.log('Shop Payment Info:', {
        isTurkishCurrency,
        originalCurrency,
        originalPrice: isTurkishCurrency ? packageData.price : packageData.usdPrice,
        usdToTryRate,
        priceInTL,
        hasVAT: isTurkishCurrency,
        finalPrice
      });

      const response = await axios.post(`api/payment/create-payment`, {
        packageId: packageData.id,
        packageName: packageData.name,
        price: finalPrice, // TL ise KDV dahil, USD ise KDV yok
        reports: packageData.reports,
        userId: userData._id,
        userName: (userData.firstName.length + userData.lastName.length < 55 ? (userData.firstName || '') + ' ' + (userData.lastName || '') : ((userData.firstName || '') + ' ' + (userData.lastName || '')).substring(0, 55)),
        userEmail: userData.email,
        userAddress: userData.address?.country || 'Türkiye',
        userPhone: userData.phone || '5555555555',
        curr: originalCurrency, // PayTR'ye her zaman TL gönder
        originalCurrency: originalCurrency, // Kayıt için orijinal para birimi
        language: currentLanguage
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('userToken')}`
        }
      });

      const result = response.data;

      if (result.success && result.token) {
        setIframeToken(result.token);
        setIframeOrderId(result.orderId);
        setOidWithExpiry(result.orderId);
        setIframeLoading(true); // Iframe yükleniyor
        setShowIframe(true);
      } else {
        throw new Error(result.error || 'Ödeme oluşturulamadı');
      }
    } catch (error) {
      if (error.response) {
        console.error('Satın alma hatası:', error.response.data, 'Status:', error.response.status);
        alert(`Ödeme işlemi sırasında bir hata oluştu: ${error.response.data?.error || error.message}\nDetay: ${JSON.stringify(error.response.data)}`);
      } else if (error.request) {
        console.error('Satın alma hatası: Sunucudan yanıt alınamadı', error.request);
        alert('Sunucudan yanıt alınamadı. Lütfen bağlantınızı kontrol edin.');
      } else {
        console.error('Satın alma hatası:', error.message);
        alert(`Ödeme işlemi sırasında bir hata oluştu: ${error.message}`);
      }
    } finally {
      setLoadingPackage(null);
    }
  };

  function setOidWithExpiry(value) {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + 60 * 1000, // expire süresi ms cinsinden
    };

    localStorage.setItem("oid", JSON.stringify(item));
  }

  return (
    <div className="shop-container" style={{ position: 'relative' }}>
      <Sidebar />
      <div className="shop-content" style={{ paddingTop: '32px', position: 'relative' }}>

        <div className="shop-header">
          <h1>{t('shop.title')}</h1>
          <p>{t('shop.subtitle')}</p>
        </div>

        <div className="pricing-container">
          {packages.map((pkg) => {
            const priceData = formatPrice(pkg);
            // İndirim hesaplama
            const discount = pkg.originalPrice ?
              Math.round(((pkg.originalPrice - pkg.price) / pkg.originalPrice) * 100) : null;

            return (
              <div key={pkg.id} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
                {pkg.popular && <div className="popular-badge">{t('shop.popularBadge')}</div>}
                {pkg.discountBadge && <div className="discount-badge">{pkg.discountBadge}</div>}

                <div className="package-header">
                  <h2 className="package-name">{pkg.name}</h2>
                  <p className="package-description">{pkg.description}</p>
                </div>

                <div className="pricing">
                  <div className="price">
                    {priceData.originalPrice && (
                      <span className="original-price">
                        {priceData.originalPrice}
                      </span>
                    )}
                    <span className="current-price">
                    {priceData.price}
                    {isTurkishCurrency && <span> {t('shop.plusVat')}</span>}
                  </span>
                  </div>
                  {pkg.unitPrice && <p className="unit-price">{pkg.unitPrice}</p>}
                  <p className="price-period">{t('shop.oneTimePayment')}</p>
                </div>

                <ul className="features-list">
                  {pkg.features.map((feature, index) => (
                    <li key={index}>
                      <span className="feature-icon-shop">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  className="purchase-btn"
                  onClick={() => handlePurchase(pkg)}
                  disabled={loadingPackage === pkg.id}
                >
                  {loadingPackage === pkg.id ? (
                    <>
                      <span className="loading-spinner-shop"></span>
                      {t('shop.processing')}
                    </>
                  ) : (
                    t('shop.purchase')
                  )}
                </button>
              </div>
            );
          })}
        </div>

        <div className="payment-info">
          <h3>{t('shop.securePayment')}</h3>
          <div className="payment-methods">
            <div className="payment-method">
              <i className="fab fa-cc-visa"></i> {t('shop.sslSecured')}
            </div>
            <div className="payment-method">
              <i className="fab fa-cc-mastercard"></i> {t('shop.paytrSecurity')}
            </div>
            <div className="payment-method">
              <i className="fas fa-university"></i> {t('shop.instantActivation')}
            </div>
          </div>
        </div>

        <div className="payment-info">
          <h3>{t('shop.paymentMethods')}</h3>
          <p>{t('shop.paymentInfo')}</p>
          <div className="payment-methods">
            <div className="payment-method">
              <i className="fab fa-cc-visa"></i> {t('shop.visa')}
            </div>
            <div className="payment-method">
              <i className="fab fa-cc-mastercard"></i> {t('shop.mastercard')}
            </div>
            <div className="payment-method">
              <i className="fas fa-university"></i> {t('shop.bankTransfer')}
            </div>
            <div className="payment-method">
              <i className="fas fa-mobile-alt"></i> {t('shop.paytr')}
            </div>
          </div>
        </div>

        {showIframe && iframeToken && (
          <div
            className="paytr-iframe-modal"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px'
            }}
          >
            <div
              style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
                position: 'relative',
                width: '600px',
                maxWidth: '95vw',
                maxHeight: '90vh',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <button
                style={{
                  position: 'absolute',
                  top: '12px',
                  right: '12px',
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer'
                }}
                onClick={() => setShowIframe(false)}
              >
                &times;
              </button>
              <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>{t('shop.payment')}</h2>
              <div style={{ position: 'relative', minHeight: '500px', flex: '1 1 auto' }}>
                {iframeLoading && (
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.95)',
                    zIndex: 10,
                    gap: '15px',
                    borderRadius: '8px'
                  }}>
                    <div className="loading-spinner-shop"></div>
                    <p style={{ color: '#64748b', fontSize: '16px', fontWeight: '500' }}>
                      {t('shop.loadingPaymentPage')}
                    </p>
                  </div>
                )}
                <script src="https://www.paytr.com/js/iframeResizer.min.js"></script>
                <iframe
                  src={`https://www.paytr.com/odeme/guvenli/${iframeToken}`}
                  title="PAYTR Payment"
                  frameBorder="0"
                  id="paytriframe"
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: '8px',
                    minHeight: '500px'
                  }}
                  allow="payment"
                  onLoad={() => setIframeLoading(false)}
                ></iframe>
                <script>iFrameResize({ },'#paytriframe');</script>
              </div>
              <div style={{ textAlign: 'center', marginTop: '12px', fontSize: '0.95rem', color: '#888' }}>
                {t('shop.orderId')} {iframeOrderId}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;
